import { View } from 'react-native';
import { useThemedStyleFunction } from "../../theme-provider";
import { ThemedText } from '../../themed-text';
import { Poi, PoiCategory } from '../../../interfaces';
import { getTranslatedProperty } from '../../../utils/localization.utils';
import { detailsContentStyle } from '../details-content.style';

type PoiDetailsContentTopProps = Poi & {
    category: PoiCategory,
};

const formatEventTime = (value: string) =>
    new Date(value).toLocaleDateString('sv-SE', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });

const PoiDetailsContentTop = (props: PoiDetailsContentTopProps) => {
    const {category, areas, startAt, endAt} = props;

    const categoryName = getTranslatedProperty('name', category);

    const formattedAreas = (areas ?? []).map((area => getTranslatedProperty('name', area)?.toLowerCase()));
    const metadata = [categoryName, ...formattedAreas].join(', ');
    const eventPeriod = startAt && endAt
        ? `${formatEventTime(startAt)} - ${formatEventTime(endAt)}`
        : undefined;

    const style = useThemedStyleFunction(detailsContentStyle);

    return (
        <View style={style.container}>
            <View style={[style.row, style.paragraph]}>
                <ThemedText style={[style.standard, style.secondary]}>{metadata}</ThemedText>
            </View>
            {eventPeriod && (
                <View style={[style.row, style.paragraph]}>
                    <ThemedText style={[style.standard, style.secondary]}>{eventPeriod}</ThemedText>
                </View>
            )}
        </View>
    )
};

export { PoiDetailsContentTop };